import React from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import {
  Box,
  Button,
  colors,
  H1,
  Modal,
  spacing,
  Typography,
  useI18nContext,
} from '@procore/core-react';
import { SingleCarousel } from '@/react/components';

const ModalLogo = styled.img`
  width: 75px;
  height: 75px;
  object-fit: cover;
  margin-right: ${spacing.lg}px;
`;

const MediaSection = styled(Modal.Section)`
  width: calc(100% - 36px);
  margin: 0 auto;

  @media (min-width: 768px) {
    width: calc(100% - 132px);
  }
`;

const ModalBody = styled(Modal.Body)`
  border-top: 1px solid ${colors.gray85};
  border-bottom: 1px solid ${colors.gray85};
  height: 100%;

  &:focus-within {
    outline: none;
  }

  @media (min-width: 768px) {
    height: 612px;
  }
`;

const ImageModal = ({
  logoURL,
  appName,
  tagline,
  slides,
  isOpen,
  imageURL,
  onClose,
}) => {
  const i18n = useI18nContext();
  return (
    <Modal
      aria-labelledby={`image-modal-${imageURL}`}
      open={isOpen}
      onClose={onClose}
      onClickOverlay={onClose}
      width="lg"
      role="dialog"
    >
      <Modal.Header onClose={onClose}>
        <ModalLogo src={logoURL} />
        <Box display="flex-column" gap="xs">
          <H1 data-testid="modal-app-name">{appName}</H1>
          <Typography
            data-testid="modal-tagline"
            className="font-size-body color-concrete"
            color="gray45"
          >
            {tagline}
          </Typography>
        </Box>
      </Modal.Header>
      <ModalBody>
        <MediaSection>
          <SingleCarousel slides={slides} />
        </MediaSection>
      </ModalBody>
      <Modal.Footer>
        <Modal.FooterButtons>
          <Button variant="teriary" onClick={onClose}>
            {i18n.t('labels.close')}
          </Button>
        </Modal.FooterButtons>
      </Modal.Footer>
    </Modal>
  );
};

ImageModal.propTypes = {
  logoURL: PT.string.isRequired,
  appName: PT.string.isRequired,
  tagline: PT.string.isRequired,
  slides: PT.arrayOf(
    PT.shape({
      url: PT.string.isRequired,
    })
  ),
  isOpen: PT.bool.isRequired,
  imageURL: PT.string.isRequired,
  onClose: PT.func.isRequired,
};

export default ImageModal;
